module.exports = __webpack_public_path__ + "01_short_grey.56171340.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_short_grey.png
// module id = BaRr
// module chunks = 0